import axiosBase from 'axios';
import ApiServiceVueApUrl from './api.service';


const axios = axiosBase.create({
	// This is development host
	baseURL:
		// 'https://dy4p61b2ou95g.cloudfront.net/detector/api',
		'https://gjmugqvas9.execute-api.ap-northeast-1.amazonaws.com/dev/api',
	timeout: 10000,
});

const ApiService = {
	async get(resource, params) {
		try {
			return await axios.get(`/${resource}`, {params: params })
		} catch (err) {
			throw new Error(`ApiService: ${err.message}`);
		}
	},

	async post(resource, body) {
		try {
			return await axios.post(`/${resource}`, body);
		} catch (err) {
			throw new Error(`ApiService: ${err.message}`);
		}
	},

	async put(resource, body) {
		try {
			return await axios.put(`/${resource}`, body);
		} catch (err) {
			throw new Error(`ApiService: ${err}`);
		}
	},

	async delete(resource, params) {
		try {
			return await axios.delete(`/${resource}`, {params: params });
		} catch (err) {
			throw new Error(`ApiService: ${err}`);
		}
	},
};
// Constant
const baseUrl = 'user/'

const UserService = {
	/**
	 * Get user info
	 * @param {Params} params 
	 * @returns {Response} response
	 */
	async getUserInfo(params) { 
		return await axios.get(`/${baseUrl}username/${params}`);
	},
	
	
	/**
	 * Singup
	 * @param {Params} params 
	 * @returns {Response} response
	 */
	async signup(params) { 
		return await axios.post(`/${baseUrl}`, params);
	},

    /**
	 * Login 
	 * @param {Params} params 
	 * @returns {Response} response
	 */
	async login(params) {
		return await ApiService.post(baseUrl + 'login', params);
	},
    /**
	 * Send request to retrieve password
	 * @param {Params} params 
	 * @returns {Response} response
	*/
	forgotPassword(params) {
		return ApiService.post(baseUrl + 'password/forgot', params);
	},
	    /**
	 * Send request to change password
	 * @param {Params} params 
	 * @returns {Response} response
	*/
	changePassword(params) {
		return ApiService.post(baseUrl + 'password/change', params);
	},
    /**
	 * Confirm verification code to change password 
	 * @param {Params} params 
	 * @returns {Response} response
	*/
	confirmPassword(params) {
		return ApiService.post(baseUrl + 'password/confirm', params);
	},
	/**
	 * Logout  
	 */
	logout() {
		sessionStorage.removeItem('id_token');
	},
	/**
	 *  check token validation
	 */
	validateToken() {
		return ApiServiceVueApUrl.get(baseUrl + 'validate')
	},
	validateUserStatus() { 
		return ApiServiceVueApUrl.get(baseUrl + 'validate/user/status')
	},
	removeUser(id) {
		return ApiServiceVueApUrl.delete(baseUrl + 'remove/' + id)
	}
};

export default UserService;